 document.addEventListener("DOMContentLoaded", function() {
    // Check if there are any SVGs with the class .svg-placeholder
    var svgPlaceholders = document.querySelectorAll('.svg-placeholder');
    if (svgPlaceholders.length > 0) {
        // Hide the section with the class .index-look
        var indexLookSection = document.querySelector('.index-look');
        if (indexLookSection) {
            indexLookSection.style.display = 'none';
        }
    }

    var svgExists = document.querySelector('.svg-placeholder') !== null;

    if (svgExists) {
        // Hide the <p> tag containing the text "Shop THE FLICK"
        var pTags = document.querySelectorAll('p');
        pTags.forEach(function(p) {
            if (p.textContent.includes("Shop THE FLICK")) {
                p.parentElement.style.display = 'none';
            }
        });
    }
  
});



document.addEventListener("DOMContentLoaded", function() {
    // Check if the user's region is already stored in sessionStorage
    const userRegion = sessionStorage.getItem('userRegion');

    if (userRegion) {
        console.log("User region already stored in sessionStorage: " + userRegion);
        handleWarningDisplay(userRegion);
    } else {
        console.log("User region not found in sessionStorage, making API request...");
        fetch('https://ipinfo.io/json?token=da03df3ff9cdfe')
            .then(response => {
                if (!response.ok) {
                    throw response; // Pass the response object to the catch block
                }
                return response.json();
            })
            .then(data => {
                sessionStorage.setItem('userRegion', data.region);
                console.log("User region fetched and stored in sessionStorage: " + data.region);
                handleWarningDisplay(data.region);
            })
            .catch(error => {
                if (error.status === 429) {
                    console.log("IPInfo rate limit exceeded. Switching to ipdata.co...");
                    fetch('https://api.ipdata.co?api-key=d9aa48353bffedf717e1d190356f61d36b1a34a60fd28ac2ee04769d')
                        .then(response => {
                            if (!response.ok) {
                                throw response;
                            }
                            return response.json();
                        })
                        .then(data => {
                            const region = data.region;
                            sessionStorage.setItem('userRegion', region);
                            console.log("User region fetched from ipdata.co and stored in sessionStorage: " + region);
                            handleWarningDisplay(region);
                        })
                        .catch(fallbackError => {
                            console.error("Error fetching location data from ipdata.co:", fallbackError);
                            console.log("Switching to ipgeolocation.io as the final fallback...");
                            fetch('https://api.ipgeolocation.io/ipgeo?apiKey=1addeb468426434d811b5ca57743075e')
                                .then(response => {
                                    if (!response.ok) {
                                        throw response;
                                    }
                                    return response.json();
                                })
                                .then(data => {
                                    const region = data.state_prov;
                                    sessionStorage.setItem('userRegion', region);
                                    console.log("User region fetched from ipgeolocation.io and stored in sessionStorage: " + region);
                                    handleWarningDisplay(region);
                                })
                                .catch(finalFallbackError => {
                                    console.error("Error fetching location data from ipgeolocation.io:", finalFallbackError);
                                });
                        });
                } else {
                    console.error("Error fetching location data from IPInfo:", error);
                }
            });
    }

    function handleWarningDisplay(region) {
        var warningDiv = document.getElementById("warning");
        if (region === 'California') {
            if (warningDiv) {
                warningDiv.style.display = "block";
            }
            console.log("User is in California, displaying warning.");
        } else {
            if (warningDiv) {
                warningDiv.style.display = "none";
            }
            console.log("User is not in California, no warning needed.");
        }
    }
});






